/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actionTypes';
import axios from 'axios';
import * as Constants from '../../../../SharedModules/AppConstants';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { commentsData, pgmDetail } from '../MaintainRebate/store/actions';
import {
  crcommentsData,
  createRebatePgmDetail,
} from '../CreateRebate/store/actions';

export const getCheckPay = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, {
      codeDomainList: [values],
    })
    .then((response) => {
      switch (values) {
        case actiontypes.CHECK_PAYEE_CD:
          dispatch({
            type: actiontypes.CHECK_PAYEE_CD,
            payload: response.data.CHECK_PAYEE_CD,
          });
          break;
        case actiontypes.STATE_CD:
          dispatch({
            type: actiontypes.STATE_CD,
            payload: response.data.STATE_CD,
          });
          break;
        case actiontypes.ADJUSTMENT_QTR_CD:
          dispatch({
            type: actiontypes.ADJUSTMENT_QTR_CD,
            payload: response.data.ADJUSTMENT_QTR_CD,
          });
          break;
        case actiontypes.DAY_COUNT_METHOD_CD:
          dispatch({
            type: actiontypes.DAY_COUNT_METHOD_CD,
            payload: response.data.DAY_COUNT_METHOD_CD,
          });
          break;
        case actiontypes.DRUG_TYPE_SOURCE_CD:
          dispatch({
            type: actiontypes.DRUG_TYPE_SOURCE_CD,
            payload: response.data.DRUG_TYPE_SOURCE_CD,
          });
          break;
        case actiontypes.ADJUSTMENT_DISPUTE_CD:
          dispatch({
            type: actiontypes.ADJUSTMENT_DISPUTE_CD,
            payload: response.data.ADJUSTMENT_DISPUTE_CD,
          });
          break;
        case actiontypes.REBATE_UNIT_TYPE_CD:
          dispatch({
            type: actiontypes.REBATE_UNIT_TYPE_CD,
            payload: response.data.REBATE_UNIT_TYPE_CD,
          });
          break;
        case actiontypes.UNIT_TYPE_CD:
          dispatch({
            type: actiontypes.UNIT_TYPE_CD,
            payload: response.data.UNIT_TYPE_CD,
          });
          break;
        case actiontypes.COVER_LETTER_PLACEMENT_CD:
          dispatch({
            type: actiontypes.COVER_LETTER_PLACEMENT_CD,
            payload: response.data.COVER_LETTER_PLACEMENT_CD,
          });
          break;
        case actiontypes.NON_CMS_DRUG_INCL_CD:
          dispatch({
            type: actiontypes.NON_CMS_DRUG_INCL_CD,
            payload: response.data.NON_CMS_DRUG_INCL_CD,
          });
          break;
        case actiontypes.URA_SOURCE_CD:
          dispatch({
            type: actiontypes.URA_SOURCE_CD,
            payload: response.data.URA_SOURCE_CD,
          });
          break;
        case actiontypes.URA_CALC_METHOD_CD:
          dispatch({
            type: actiontypes.URA_CALC_METHOD_CD,
            payload: response.data.URA_CALC_METHOD_CD,
          });
          break;
        case actiontypes.INT_CALC_METHOD_CD:
          dispatch({
            type: actiontypes.INT_CALC_METHOD_CD,
            payload: response.data.INT_CALC_METHOD_CD,
          });
          break;
        case actiontypes.DETAIL_LEVEL_ON_INVOICE_CD:
          dispatch({
            type: actiontypes.DETAIL_LEVEL_ON_INVOICE_CD,
            payload: response.data.DETAIL_LEVEL_ON_INVOICE_CD,
          });
          break;
        case actiontypes.ENROLLMENT_TIMING_CD:
          dispatch({
            type: actiontypes.ENROLLMENT_TIMING_CD,
            payload: response.data.ENROLLMENT_TIMING_CD,
          });
          break;
        default:
      }
    })
    .catch((response) => {
      switch (values) {
        case actiontypes.CHECK_PAYEE_CD:
          dispatch({ type: actiontypes.CHECK_PAYEE_CD, payload: [] });
          break;
        case actiontypes.STATE_CD:
          dispatch({ type: actiontypes.STATE_CD, payload: [] });
          break;
        case actiontypes.ADJUSTMENT_QTR_CD:
          dispatch({ type: actiontypes.ADJUSTMENT_QTR_CD, payload: [] });
          break;
        case actiontypes.DAY_COUNT_METHOD_CD:
          dispatch({ type: actiontypes.DAY_COUNT_METHOD_CD, payload: [] });
          break;
        case actiontypes.DRUG_TYPE_SOURCE_CD:
          dispatch({ type: actiontypes.DRUG_TYPE_SOURCE_CD, payload: [] });
          break;
        case actiontypes.ADJUSTMENT_DISPUTE_CD:
          dispatch({ type: actiontypes.ADJUSTMENT_DISPUTE_CD, payload: [] });
          break;
        case actiontypes.UNIT_TYPE_CD:
          dispatch({ type: actiontypes.UNIT_TYPE_CD, payload: [] });
          break;
        case actiontypes.COVER_LETTER_PLACEMENT_CD:
          dispatch({
            type: actiontypes.COVER_LETTER_PLACEMENT_CD,
            payload: [],
          });
          break;
        case actiontypes.NON_CMS_DRUG_INCL_CD:
          dispatch({ type: actiontypes.NON_CMS_DRUG_INCL_CD, payload: [] });
          break;
        case actiontypes.URA_SOURCE_CD:
          dispatch({ type: actiontypes.URA_SOURCE_CD, payload: [] });
          break;
        case actiontypes.URA_CALC_METHOD_CD:
          dispatch({ type: actiontypes.URA_CALC_METHOD_CD, payload: [] });
          break;
        case actiontypes.INT_CALC_METHOD_CD:
          dispatch({ type: actiontypes.INT_CALC_METHOD_CD, payload: [] });
          break;
        case actiontypes.DETAIL_LEVEL_ON_INVOICE_CD:
          dispatch({
            type: actiontypes.DETAIL_LEVEL_ON_INVOICE_CD,
            payload: [],
          });
          break;
        case actiontypes.ENROLLMENT_TIMING_CD:
          dispatch({ type: actiontypes.ENROLLMENT_TIMING_CD, payload: [] });
          break;
        default:
      }
    });
};

export const getDropdownByCode = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS}`, {
      codeDomainList: values,
    })
    .then((response) => response.data)
    .catch((err) => ({}));
};

export const getExistingCorrLinkIds = (value, val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, { corrLinkId: value })
    .then((response) => {
      if (val === 'maintain') dispatch(commentsData(response.data.data));
      if (val === 'createrebate') dispatch(crcommentsData(response.data.data));
      return response.data;
    })
    .catch(() => {
      if (val === 'maintain') dispatch(commentsData([]));
      if (val === 'createrebate') dispatch(crcommentsData([]));
      return {};
    });
};
export const getDisputeSpecialists = () => () => {
  return axios
    .post(serviceEndPoint.GET_DISPUTE_SPECIALIST)
    .then((response) => {
      let finalResponse = [];
      if (
        response?.data?.message === 'Success' &&
        response?.data?.status === '001'
      ) {
        finalResponse = response?.data?.secUsers || [];
      }
      return finalResponse;
    })
    .catch(() => {
      return [];
    });
};


export const getLetterSenders = (value, val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LETTER_SENDER)
    .then((response) => {
      // dispatch({
      //   type: actiontypes.GET_LETTER_SENDERS,
      //   payload: response.data.data,
      // });
      return response.data.data;
    })
    .catch(() => {
      // dispatch({ type: actiontypes.GET_LETTER_SENDERS, payload: [] });
      return [];
    });
};

export const getClaimCodeList = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.CLAIM_REBATE_PGM_LIST)
    .then((response) => {
      // dispatch({
      //   type: actiontypes.CLAIM_REBATE_PGM_CD,
      //   payload: response.data.data,
      // });
      return response.data.data;
    })
    .catch(() => {
      // dispatch({ type: actiontypes.CLAIM_REBATE_PGM_CD, payload: [] });
      return [];
    });
};

export const getQtrAndUnitType = (values, detail, callFrom) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_LAST_QTR, values)
    .then((response) => {
      let data = response.data?.data?.[0];
      let existData = detail;
      existData.claimRebateProgramCd = values.claimRebateProgramCd;
      if (data) {
        existData.lastQtrWithoutClaims = data.lastQtrWithoutClaims;
        existData.rebateUnitTypeCd = data.rebateUnitTypeCd;
      }
      if (callFrom === 'createRebate')
        dispatch(createRebatePgmDetail(existData));
      if (callFrom === 'maintainRebate') dispatch(pgmDetail(existData));
    })
    .catch(() => {});
};

export const getDefaultAuditValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.DEFAULT_AUDIT_REQ)
    .then((response) => {
      let data = response.data?.data?.paramTestVO;
      dispatch({ type: actiontypes.DEFAULT_SYS_AUDIT, payload: data });
    })
    .catch((response) => {
      dispatch({ type: actiontypes.DEFAULT_SYS_AUDIT, payload: [] });
    });
};
